<template>
  <o-section
    style="min-height: 350px"
    :headClasses="headClass"
    v-if="field_visible && visible"
    :title="field_label"
    not-closable
  >
    <f-widget-list
      :item="the_item[field.code]"
      @change="change"
      @error="handleError"
      :fields="field.fields"
      :design="design"
      :disabled="is_disabled"
      :selector="selector"
      :form-state="formState"
      :form-context="nestedFormContext"
      @fields-change="fieldsChanged"
    ></f-widget-list>
  </o-section>
</template>

<script>
import { setter } from "../setter";
import OSection from "../../../vue-ocom/components/layout/OSection.vue";
import FWidgetList from "../FWidgetList.vue";
import ContainerWidgetMixin from "../ContainerWidgetMixin.js";

export default {
  name: "WizardStepWidget",
  mixins: [ContainerWidgetMixin],
  components: { FWidgetList, OSection },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    // visible: { type: Boolean, default: false },
  },
  computed: {
    visible() {
      if (this.design) {
        return true;
      }

      return this.field.visible;
    },

    headClass() {
      return "";
    },
  },
  created: function () {
    // this.field.visible = true

    if (this.item && !(this.field.code in this.item)) {
      setter(this, this.item, this.field.code, {});
    }
    console.info("thix", this.design);
  },

  watch: {
    design: function (value) {
      console.info("xx-watch", value);
    },
  },
};
</script>

<style scoped></style>
